import { NorwegianId } from 'norwegian-national-id-validator';

export const validatePersonalCode = (personalCode) => {
  return !personalCode || NorwegianId(personalCode).isValid();
};
